import React from "react";
import { Upload, Button, message, Tooltip } from "antd";
import { PictureOutlined } from "@ant-design/icons";
import ApiUserUploads from "../../api/user-uploads";

const MAX_SIZE = 10 * 1024 * 1024; // 10MB
const ALLOWED = /^image\/(png|jpe?g|webp|gif)$/i;

const ImageUpload = ({
  articleId,
  legalDocumentId,
  disabled = false,
  onInsertImage, // ({src, uploadId, alt?})
  dailyTaskId,
  onInsertHtml,  // optional
}) => {
  const uploadImage = async (file) => {
    if (!articleId && !legalDocumentId && !dailyTaskId) {
      message.error("No target specified");
      return Upload.LIST_IGNORE;
    }
    if (!ALLOWED.test(file.type)) {
      message.error("Only PNG, JPG, WEBP or GIF are allowed");
      return Upload.LIST_IGNORE;
    }
    if (file.size > MAX_SIZE) {
      message.error("File is too large (max 10MB)");
      return Upload.LIST_IGNORE;
    }

    try {
      const reader = new FileReader();
      const base64 = await new Promise((resolve, reject) => {
        reader.onload = () => {
          const result = String(reader.result || "");
          resolve(result.includes(",") ? result.split(",")[1] : result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      const mimeType = file.type;

      let response;
      if (articleId) {
        response = await ApiUserUploads.uploadImage({ articleId, base64, mimeType });
      } else if (dailyTaskId) {
        response = await ApiUserUploads.uploadTaskImage({ dailyTaskId, base64, mimeType });
      } else {
        response = await ApiUserUploads.uploadLegalDocImage({ legalDocumentId, base64, mimeType });
      }

      const signedUrl = response?.data?.signedUrl;
      const uploadId = response?.data?.userUpload?.id;

      if (!signedUrl || !uploadId) throw new Error("Invalid upload response");

      // preferred: insert node attrs via tiptap command
      if (onInsertImage) {
        onInsertImage({ src: signedUrl, uploadId });
      } else if (onInsertHtml) {
        onInsertHtml(
          `<img src="${signedUrl}" alt="image-${uploadId}" title="Image ${uploadId}" id="${uploadId}" data-id="${uploadId}" style="max-width:100%;height:auto;" />`
        );
      }
    } catch (err) {
      console.error("❌ Upload failed:", err);
      message.error("Upload failed");
    }

    return Upload.LIST_IGNORE;
  };

  return (
    <Tooltip title="Upload image">
      <Upload
        accept="image/png,image/jpeg,image/webp,image/gif"
        beforeUpload={uploadImage}
        showUploadList={false}
        disabled={disabled}
      >
        <Button
          type="text"
          className="lf-editor__iconbtn"
          icon={<PictureOutlined />}
          disabled={disabled}
        />
      </Upload>
    </Tooltip>
  );
};

export default ImageUpload;